/**
 * Enums
 */
export enum AssetType {
  Video = "Video",
  Image = "Image",
  Audio = "Audio",
  Document = "Document",
}

export enum ProcessingStatus {
  Pending = "Pending",
  Processing = "Processing",
  Complete = "Complete",
  Failed = "Failed",
}
